import { faker } from "@faker-js/faker";
import dayjs from "dayjs";

// for development only
export const generateFakeUser = (
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void,
  setFieldTouched: (
    field: string,
    isTouched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => void
) => {
  const firstName = faker.name.firstName();
  const lastName = faker.name.lastName();
  setFieldValue("firstName", firstName);
  setFieldValue("lastName", lastName);
  setFieldValue(
    "email",
    faker.internet.email(firstName, lastName, "fanrally.com")
  );
  setFieldValue("password", "welcome1");
  setFieldValue("confirmPassword", "welcome1");
  setFieldValue("phone", faker.phone.number("(012)-345-6789"));
  setFieldValue(
    "birthdate",
    dayjs(faker.date.birthdate({ min: 10, max: 99, mode: "age" })).format(
      "MM/DD/YYYY"
    )
  );

  setTimeout(() => {
    // trigger form validation
    setFieldTouched("firstName", true);
  });
};
